import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {ResourceAllocationEditType} from "../../types/resourceAllocationEdit.type";
import {AddServiceSequenceModel} from "../../models/add-service-sequence.model";

export class resourceAllocationPanelEditCtrl implements IController {

  template?: any;
  allocation: any;
  resource: any;
  branchIds: any;
  isCreate: boolean;
  isDuplicate: boolean;
  resourceAllocationEditType?: ResourceAllocationEditType;
  onClose: Function;
  onUpdateAllocation: Function;
  onCreateAllocation: Function;

  public enableAddRecurringServiceBySkillMap: any;
  public resourceAllocationEditTypes: typeof ResourceAllocationEditType = ResourceAllocationEditType;
  public todayDate: string;
  public serviceAreasServiceTypes: ServiceAreasServiceType[];
  public allocationCopy: any;
  public branchIdsCopy: any;

  public recurringType: any;
  public recurringInterval: number;
  public extraTimeInMinutes: number;
  public serviceAreaOptionIds: any;
  public serviceAreasPriorities: any;
  public days: any;
  public isBulkWeekly: any;
  public isSameDate: boolean;
  public isLocationSettingsActive: boolean;
  public isServiceAreaSectionExpanded: boolean;
  public isSegmentTimeSyncEnabled: boolean;
  public crossDaysEnabled: boolean = false;

  /* @ngInject */
  constructor(private commonsConstants, private resourcesConstants, private splitService, private $log,
              private moment, private siteContextService: SiteContextService, private deliveriesDialogService) {
    this.serviceAreasServiceTypes = [ServiceAreasServiceType.Planning];
  }

  $onInit() {

    this.todayDate = this.moment().startOf('day').valueOf();
    this.branchIdsCopy = angular.copy(this.branchIds);
    this.days = angular.copy(this.commonsConstants.daysCheckboxConfig);

    this.allocationCopy = !this.isCreate || (this.isCreate && this.isDuplicate) ? angular.copy(this.allocation) :
      {
        resourceAllocationId: this.resource.id,
        schedule: {
          startTime: _.get(this.allocation, 'schedule.startTime') ? this.allocation.schedule.startTime : undefined,
          endTime: _.get(this.allocation, 'schedule.endTime') ? this.allocation.schedule.endTime : undefined,
          zoneIdName: this.splitService.getTimeZone()
        },
        locationSettings: undefined,
        extraTimeInMillis: undefined,
        gapInMinutes: undefined,
        details: [],
        serviceAreaIds: _.get(this.resource, 'serviceAreaIds', []),
        branchIds: this.branchIdsCopy,
        segments: []
      };

    this._setSegmentTimeSyncState();

    if (!this.isCreate) {
      this.isSameDate = this.moment(this.allocationCopy.schedule.startTime).isSame(this.moment(this.allocationCopy.schedule.endTime), 'day');

      if (this.recurringType === 'WEEKLY') {
        _.forOwn(this.days, (value, key) => {
          if (_.includes(this.template.schedule.byWeekDay, key)) {
            value.enabled = true;
          }
        })
      }
    }
    // const rrule = require('rrule');
    // const ruleOptions = rrule.RRule.fromString(_.get(this.allocationCopy, 'schedule.rrule') || '').origOptions;
    // this.recurringType = _.find(this.rruleTypes, (t) => {
    //   return t.freq === ruleOptions.freq;
    // });

    // this.recurringType = this.template?.schedule?.freq ? _.find(this.commonsConstants.recurringTypes, (rt) => {
    //   return rt === this.template.schedule.freq;
    // }) : undefined
    //
    //
    //
    // this.recurringInterval = this.template?.schedule?.interval || 1;


    if (this.allocationCopy.details) {
      this.allocationCopy.details = _.sortBy(this.allocationCopy.details, ['sequence']);
    } else if (this.allocationCopy.recurringServiceDetails) {
      this.allocationCopy.recurringServiceDetails = _.sortBy(this.allocationCopy.recurringServiceDetails, ['sequence']);
    } else {
      this.allocationCopy.details = [];
    }


    this.extraTimeInMinutes = _.get(this.allocationCopy, 'extraTimeInMillis') / 60000 || undefined;
    this.serviceAreaOptionIds = _.get(this.resource, 'serviceAreaIds');
    this.isBulkWeekly = {
      enabled: false
    };

    this.allocationCopy.segments = _.get(this.allocationCopy, 'segments');
    if (_.isUndefined(this.allocationCopy.segments)) {
      this.allocationCopy.segments = [];
    }
    this.serviceAreasPriorities = this.resourcesConstants.serviceAreasPriorities;
    this.isLocationSettingsActive = !!_.get(this.allocationCopy, 'locationSettings', false);

    this.crossDaysEnabled = !this._getIsSameDay(
      this.allocationCopy.schedule.startTime,
      this.allocationCopy.schedule.endTime
    );

  }

  $onChanges(changes) {
    if (changes.allocation && !changes.allocation.isFirstChange()) {
      this.allocation = changes.allocation.currentValue;
      this.$onInit();
    }

    if (changes.resource && !changes.resource.isFirstChange()) {
      this.resource = changes.resource.currentValue;
      this.$onInit();
    }

    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      this.branchIds = changes.branchIds.currentValue;
      this.$onInit();
    }

    if (changes.template) {
      this.recurringType = this.template?.schedule?.freq ? _.find(this.commonsConstants.recurringTypes, (rt) => {
        return rt === this.template.schedule.freq;
      }) : undefined

      this.recurringInterval = this.template?.schedule?.interval || 1;

      if (this.allocationCopy) {
        this._setSegmentTimeSyncState();
      }
    }

    if (changes.resourceAllocationEditType && !changes.resourceAllocationEditType.isFirstChange() && this.allocationCopy) {
      this._setSegmentTimeSyncState();
    }

    if (changes.resource) {
      this.enableAddRecurringServiceBySkillMap = {};
      this.resource?.requiredSkills?.forEach((s) => {
        this.enableAddRecurringServiceBySkillMap[s] = true;
      })
    }

  };

  // ******************************
  //        Public methods
  // ******************************

  onToggleLocationSettingsActivation(isActive) {
    this.allocationCopy.locationSettings = isActive ? (this.allocation.locationSettings ? angular.copy(this.allocation.locationSettings) : {}) : undefined;
  }

  onCrossDaysToggle() {
    this.crossDaysEnabled = !this.crossDaysEnabled;
    const isSameDate = this._getIsSameDay(this.allocationCopy.schedule.startTime, this.allocationCopy.schedule.endTime);

    if (!this.crossDaysEnabled && !isSameDate) {
      this.allocationCopy.schedule.endTime = this.moment(this.allocationCopy.schedule.startTime).endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
    }
  }

  onIgnoreSegmentTimeSyncToggle(isSegmentTimeSyncEnabled) {
    this.isSegmentTimeSyncEnabled = isSegmentTimeSyncEnabled;
    if (this.allocationCopy) {
      this.allocationCopy.ignoreSegmentTimeSync = !isSegmentTimeSyncEnabled;
    }
  }

  onRangeChange(from, to) {
    if (!this.allocationCopy) {
      return;
    }

    if (this.allocationCopy.ignoreSegmentTimeSync && this.allocationCopy.schedule.startTime && from) {
      const millisecondsDiff = this.allocationCopy.schedule.startTime - from;
      if (this.allocationCopy.segments) {
        this.allocationCopy.segments.forEach((s) => {
          s.offsetInMillis = s.offsetInMillis + millisecondsDiff;
        });
      }
    }

    this.allocationCopy.schedule.startTime = from;
    this.allocationCopy.schedule.endTime = to;
  }

  onExtraTimeChange(extraTimeInMinutes) {
    this.allocationCopy.extraTimeInMillis = extraTimeInMinutes * 60000;
  }

  onSelectServiceAreas(serviceAreaIds) {
    this.allocationCopy.serviceAreaIds = serviceAreaIds;
  }

  onSegmentFromChange(fromTime, segmentId) {
    const diffOffset = fromTime - this.allocationCopy.schedule.startTime;
    const segmentIdx = this._onFindSegmentIdx(segmentId);

    this.allocationCopy.segments[segmentIdx].offsetInMillis = diffOffset;
  }

  onSegmentToChange(toTime, segmentId) {
    const segmentIdx = this._onFindSegmentIdx(segmentId);
    const diffDuration = toTime - this.allocationCopy.segments[segmentIdx].offsetInMillis - this.allocationCopy.schedule.startTime;

    this.allocationCopy.segments[segmentIdx].durationInMillis = diffDuration;
  }

  onSetSegmentDurationInMillis(durationInMinutes, segmentId) {
    const segmentIdx = this._onFindSegmentIdx(segmentId);

    this.allocationCopy.segments[segmentIdx].durationInMillis = durationInMinutes * 60000;
  }

  onAddSegment(index, event) {
    let offSetToAdd: number = 0
    let durationToAdd: number = 0
    let priorityToAdd = undefined;
    if (index) {
      const prevSegment = _.get(this.allocationCopy, `segments[${index - 1}]`);
      const nextSegment = _.get(this.allocationCopy, `segments[${index}]`);
      offSetToAdd = _.get(prevSegment, 'offsetInMillis', 0) + _.get(prevSegment, 'durationInMillis', 0);
      durationToAdd = nextSegment ? _.get(nextSegment, 'offsetInMillis') - offSetToAdd : _.get(prevSegment, 'durationInMillis', undefined);
      if (durationToAdd === 0) {
        durationToAdd = _.get(prevSegment, 'durationInMillis', undefined)
      }
      priorityToAdd = _.get(prevSegment, `planningAreas[${_.get(prevSegment, 'planningAreas.length') - 1}].priority`, undefined)
    }

    const newSegment = {
      id: this.moment().valueOf().toString(),
      offsetInMillis: offSetToAdd,
      durationInMillis: durationToAdd,
      planningAreas: [
        {
          id: this.moment().valueOf(),
          areaId: undefined,
          priority: priorityToAdd
        }
      ]
    }
    _.get(this.allocationCopy, 'segments').splice(index, 0, newSegment);
    this.allocationCopy.segments = angular.copy(this.allocationCopy.segments);
  }

  onAddServiceArea(segmentId, event) {
    const newServiceArea = {
      id: (Date.now()).toString(),
      areaId: undefined,
      priority: undefined
    }
    const segmentIdx = this._onFindSegmentIdx(segmentId);

    this.allocationCopy.segments[segmentIdx].planningAreas.push(newServiceArea);
  }

  onRemoveServiceArea(segmentId, areaId, event) {
    const segmentIdx = this._onFindSegmentIdx(segmentId);
    const areaIdx = _.findIndex(this.allocationCopy.segments[segmentIdx].planningAreas, (a: any) => {
      return a.id === areaId;
    });

    this.allocationCopy.segments[segmentIdx].planningAreas.splice(areaIdx, 1);
  }

  onRemoveSegment(segmentId) {
    const segmentIdx = this._onFindSegmentIdx(segmentId);
    this.allocationCopy.segments.splice(segmentIdx, 1);
  }

  onRecurringChange(recurringType) {
    this.recurringType = recurringType;
    this.isBulkWeekly.enabled = !!this.recurringType;
  }

  onAccountSelect(account, sequenceDetails, $index) {
    sequenceDetails.holderId = account?.id;
  }

  onDepotSelect(depot, sequenceDetails, $index) {
    sequenceDetails.holderId = depot?.id;
  }

  onRecurringServiceChange(recurringService, sequenceDetails, $index) {
    sequenceDetails.recurringServiceTemplateId = recurringService?.id;
  }

  onRemoveRecurringService($index) {
    this.allocationCopy.recurringServiceDetails.splice($index, 1);
  }

  onAddLocationSequence() {
    if (!this.allocationCopy.details) {
      this.allocationCopy.details = [];
    }
    this.allocationCopy.details.push({
      holderId: undefined,
      sequence: this.allocationCopy.details.length + 1,
      type: "ACCOUNT"
    })
  }

  onLocationTypeChange(sequenceDetails, type) {
    sequenceDetails.type = type;
    sequenceDetails.holderId = undefined;
  }

  onRemoveLocation($index) {
    this.allocationCopy.details.splice($index, 1);
  }

  onLocationSettingsChange(locationSettings) {
    this.allocationCopy.locationSettings = locationSettings;
  }

  onSequenceLocationTypeSelect() {
    if (!this.allocationCopy.details) {
      this.allocationCopy.details = this.allocation.details || [];
    }
    this.allocationCopy.recurringServiceDetails = undefined;
  }

  onSequenceRecurringServicesTypeSelect() {
    if (!this.allocationCopy.recurringServiceDetails) {
      this.allocationCopy.recurringServiceDetails = this.allocation.recurringServiceDetails || [];
    }
    this.allocationCopy.details = undefined;
  }

  onAddEmptyRecurringServiceSequence($event) {
    this.allocationCopy.recurringServiceDetails.push({
      recurringServiceTemplateId: undefined,
      sequence: this.allocationCopy.recurringServiceDetails.length + 1
    })
  }

  onAddRecurringServiceSequence($event, serviceType) {
    const notBefore = this.allocationCopy.schedule.startTime;
    const notAfter = this.allocationCopy.schedule.endTime;
    const byWeekDay = this.template?.schedule.byWeekDay;
    const endRecurring = (!this.recurringType || (this.resourceAllocationEditType === ResourceAllocationEditType.EVENT)) ? notAfter : undefined;
    this.deliveriesDialogService.createRecurringService($event, serviceType, undefined, notBefore, notAfter, this.recurringType, byWeekDay, endRecurring, this.template?.schedule?.interval, this.resource.zoneId)
      .then((recurringServicePayload) => {
        this.allocationCopy.recurringServiceDetails.push({
          recurringServiceTemplate: recurringServicePayload,
          sequence: this.allocationCopy.recurringServiceDetails.length + 1
        })
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  isDaysSelected() {
    return _.find(this.days, (d) => {
      return !!d.enabled;
    })
  }

  onTimeZoneChange(zoneId) {
    this.allocationCopy.schedule.zoneIdName = zoneId;
  }

  onUseResourceTimezone() {
    this.allocationCopy.schedule.zoneIdName = this.resource.zoneId;
  }

  onUpdate(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        const allocationCopy = angular.copy(this.allocationCopy);
        // allocationCopy.schedule.zoneIdName = this.splitService.getTimeZone();

        if (this.recurringType) {
          allocationCopy.schedule.interval = this.recurringType ? this.recurringInterval : undefined;
          allocationCopy.schedule.freq = this.recurringType;
          allocationCopy.schedule.startRecurring = this.template?.schedule?.startRecurring;
          allocationCopy.schedule.endRecurring = this.template?.schedule?.endRecurring;
          allocationCopy.schedule.exceptions = this.template?.schedule?.exceptions;
          // allocationCopy.schedule.startRecurring = this.recurringType ? this.allocationCopy.schedule.startTime : undefined;

          if (allocationCopy.schedule.freq && !_.isEqual(allocationCopy.schedule.freq, 'DAILY')) {
            // allocationCopy.schedule.byWeekDay = this.allocationCopy.schedule.byWeekDay;
            allocationCopy.schedule.byWeekDay = this.template?.schedule?.byWeekDay;
          } else {
            allocationCopy.schedule.byWeekDay = [];
          }


          if (!!this.allocationCopy.recurringServiceDetails) {
            this.allocationCopy.recurringServiceDetails.forEach((d, index) => {
              d.sequence = (index + 1);
            })

            // const payload: AddServiceSequenceModel = {
            //   recurringServiceTemplateSequences: _.map(this.allocationCopy.recurringServiceDetails, (d) => {
            //     return {
            //       recurringServiceTemplateId: d.recurringServiceTemplateId,
            //       recurringServiceTemplate: d.recurringServiceTemplate,
            //       sequence: d.sequence
            //     }
            //   })
            // }
            //
            // this.onCreateRecurringServiceSequence({payload: payload, allocation: this.allocation});
          } else {
            _.forEach(allocationCopy.details, (allocationDetail, i) => {
              allocationDetail.sequence = i + 1;
            })
          }

        }

        this.onUpdateAllocation({allocation: allocationCopy});
      }

    }
  }

  onCreate(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        var allocationsToCreate = [];
        const allocationCopy = angular.copy(this.allocationCopy);
        // allocationCopy.schedule.zoneIdName = this.splitService.getTimeZone();

        const isWeekly = _.isEqual(this.recurringType, 'WEEKLY');
        const weekDays = isWeekly ? _.filter(this.days, (value, key) => {
          return value.enabled;
        }) : [];

        if (this.recurringType) {
          // const rrule = require('rrule');
          // var roleTest = new rrule.RRule({
          //   freq: _.get(rrule, this.recurringType.value),
          //   dtstart: this.moment(this.allocationCopy.schedule.startTime).toDate(),
          // });
          // allocationCopy.schedule.rrule = roleTest.toString();

          allocationCopy.schedule.interval = this.recurringType ? this.recurringInterval : undefined;
          allocationCopy.schedule.freq = this.recurringType;
          allocationCopy.schedule.startRecurring = this.allocationCopy.schedule.startTime;

          _.forEach(allocationCopy.details, (allocationDetail, i) => {
            allocationDetail.sequence = i + 1;
          })

          if (this.isBulkWeekly.enabled) {
            _.forEach(_.map(weekDays, 'key'), (wd) => {
              const allocationBulkCopy = angular.copy(allocationCopy)
              allocationBulkCopy.schedule.byWeekDay = [wd];
              allocationsToCreate.push(allocationBulkCopy);
            })
          } else {
            if (allocationCopy.schedule.freq && _.isEqual(allocationCopy.schedule.freq, 'WEEKLY')) {
              allocationCopy.schedule.byWeekDay = _.map(weekDays, 'key');
            } else {
              allocationCopy.schedule.byWeekDay = [];
            }
          }
        }

        if (_.isEmpty(allocationsToCreate)) {
          allocationsToCreate.push(allocationCopy);
        }

        this.onCreateAllocation({allocation: allocationsToCreate});
      }

    }
  }

  // ******************************
  //        Private methods
  // ******************************

  private _onFindSegmentIdx(segmentId) {
    return _.findIndex(this.allocationCopy.segments, (s: any) => {
      return s.id === segmentId;
    });
  }

  private _getIsSameDay(startTime, endTime) {
    return this.moment(startTime).isSame(this.moment(endTime), 'day');
  }

  private _setSegmentTimeSyncState() {
    const ignoreSegmentTimeSync = this._getIgnoreSegmentTimeSync();
    this.allocationCopy.ignoreSegmentTimeSync = ignoreSegmentTimeSync;
    this.isSegmentTimeSyncEnabled = !ignoreSegmentTimeSync;
  }

  private _getIgnoreSegmentTimeSync() {
    const shouldUseTemplateValue = !this.isCreate &&
      !!this.template &&
      this.resourceAllocationEditType !== ResourceAllocationEditType.EVENT &&
      !_.isUndefined(this.template.ignoreSegmentTimeSync);

    if (shouldUseTemplateValue) {
      return this.template.ignoreSegmentTimeSync;
    }

    if (!_.isUndefined(this.allocationCopy.ignoreSegmentTimeSync)) {
      return this.allocationCopy.ignoreSegmentTimeSync;
    }

    if (!_.isUndefined(_.get(this.template, 'ignoreSegmentTimeSync'))) {
      return this.template.ignoreSegmentTimeSync;
    }

    return false;
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationPanelEdit', {
    bindings: {
      template: '<?',
      allocation: '<',
      resource: '<',
      branchIds: '<',
      isCreate: '<',
      isDuplicate: '<',
      resourceAllocationEditType: '<?',
      onClose: '&',
      onUpdateAllocation: '&',
      onCreateAllocation: '&'
    },
    template: require('./resource-allocation-panel-edit.html').default,
    controller: resourceAllocationPanelEditCtrl
  });
